import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { AlertService } from './alert/alert.service';

/** Observable wrapper around online/offline window events. */
@Injectable({
  providedIn: 'root',
})
export class ConnectionStatusService {
  private _connectionStatus = new BehaviorSubject<'online' | 'offline'>(
    'online'
  );
  connectionStatus$ = this._connectionStatus.asObservable();

  constructor(private alertService: AlertService) {}

  init(): void {
    const onlineEvent = fromEvent(window, 'online');
    const offlineEvent = fromEvent(window, 'offline');

    onlineEvent.subscribe(() => {
      console.log('Online');
      this._connectionStatus.next('online');
      this.alertService.setAlert({
        type: 'info',
        message: 'Online mode resumed.',
      });
    });

    offlineEvent.subscribe(() => {
      console.log('Offline');
      this._connectionStatus.next('offline');
      this.alertService.setAlert({
        type: 'warning',
        message: 'Offline mode detected. Displaying saved data.',
      });
    });
  }
}
